import CourseList from '../components/CourseList';

export default function StepSelectCourse({
  loading,
  courses,
  selectedCourse,
  onSelect,
  app,
}) {
  return (
    <div>
      <h4>Select a Course</h4>
      <CourseList
        loading={loading}
        courses={courses}
        selectedCourse={selectedCourse}
        onSelect={onSelect}
        app={app}
      />
    </div>
  );
}
